import moment from 'moment-jalaali';

export const persianDate = (date) => {
    moment.loadPersian();
    let m = moment(date, 'YYYY-M-DD');
    m.locale('fa');
    let shamsiDate = m.format('jDD/jYYYY');
    for (var i = 0; i < 10; i++) {
        shamsiDate = shamsiDate.replace(new RegExp(i.toString(), 'g'), String.fromCharCode(0x06F0 + i));
    }
    shamsiDate = shamsiDate.replace('/', ` ${m.format('jMMMM')} `);
    return shamsiDate
}